import React, { useState } from 'react';
import { getAvatarUrl } from '../../utils/avatarUtils';

interface SafeImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSeed: string; // The user ID, username, or name to generate a DiceBear avatar if the original src fails
}

export const SafeImage: React.FC<SafeImageProps> = ({ src, fallbackSeed, alt, ...props }) => {
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    if (!hasError) {
      setHasError(true);
    }
  };

  const imageSrc = (hasError || !src) ? getAvatarUrl(fallbackSeed) : src;

  return (
    <img
      src={imageSrc}
      alt={alt || "Avatar"}
      onError={handleError}
      referrerPolicy="no-referrer"
      {...props}
    />
  );
};
